<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <table-equipment class="mt-5" :list="form.equipmentList" @updateList="updateList" :isPrint="isPrint" :isReadonly="board.readonly"></table-equipment>

    <!--    작업구분-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 작업구분</h5>
      </vs-col>
    </vs-row>

    <!-- PC: 가로 배치, 모바일: 세로 배치 -->
    <div class="flex flex-col xl:grid xl:grid-cols-3 gap-4 mt-4">
      <div v-for="checkbox in checkboxItems" :key="checkbox.key" class="flex items-center">
        <!--  프린트 모드  -->
        <div v-if="isPrint" class="flex items-center">
          <div v-if="form[checkbox.key]" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
          <span class="flex-1">
            {{ checkbox.title }}
          </span>
        </div>
        <!--  일반 모드  -->
        <div v-else>
          <span class="flex">
            <vs-checkbox :disabled="board.readonly" v-model="form[checkbox.key]"></vs-checkbox>
            {{ checkbox.title }}
          </span>
        </div>
      </div>
    </div>

    <!-- 체감온도 -->
    <div v-if="form.check_1">
      <vs-row class="mt-8">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 체감온도</h5>
          <vx-tooltip title="체감온도 산출표" :html="'자세한 정보를 보려면 클릭하세요'" style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
            <div style="color: #7e72f2; cursor: pointer" class="flex flex-row items-center ml-4" @click="showPopup = true">
              <feather-icon icon="AlertCircleIcon" style="width: 18px" />
              <span class="ml-2" style="font-size: 14px">체감온도 산출표</span>
            </div>
          </vx-tooltip>
        </vs-col>
      </vs-row>

      <div class="w-full mt-4" style="border: 1px solid #cdcdcd; padding: 21px; font-size: 14px">
        <div class="flex flex-row items-center gap-4">
          <div>온도(℃)</div>
          <div><number-input v-model="form.temperature" :max="40" :min="-20" /></div>
          <div class="ml-3">습도(%)</div>
          <div><number-input v-model="form.humidity" :max="100" :min="0" /></div>
        </div>
        <div class="flex flex-row items-center gap-4 mt-4">
          <div>체감온도 :</div>
          <div style="font-size: 18px; font-weight: 700; color: #3c3c3c">{{ form.temperature_feel }}℃</div>
          <div v-if="form.temperature_feel >= 38" class="ml-3 temp-tag" style="background: #ea5455">위험</div>
          <div v-else-if="form.temperature_feel >= 35" class="ml-3 temp-tag" style="background: #ff9f43">경고</div>
          <div v-else-if="form.temperature_feel >= 33" class="ml-3 temp-tag" style="background: #ffcd43">주의</div>
          <div v-else-if="form.temperature_feel >= 31" class="ml-3 temp-tag" style="background: #00cfe8">관심</div>
        </div>
      </div>
    </div>

    <!--    폭염 작업-->
    <TableInspectMerge class="print-page-break mt-8" :is-print="isPrint" :is-readonly="board.readonly" :title="inspectionTitle_1" v-model="form.inspectList_1" v-if="form.check_1" />
    <!--    풍수해 작업-->
<!--    <TableInspectMerge class="print-page-break mt-8" :is-print="isPrint" :is-readonly="board.readonly" :title="inspectionTitle_2" v-model="form.inspectList_2" v-if="form.check_2" />-->
    <!--    한랭 작업-->
    <TableInspectMerge class="print-page-break mt-8" :is-print="isPrint" :is-readonly="board.readonly" :title="inspectionTitle_3" v-model="form.inspectList_3" v-if="form.check_3" />

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- 체감온도 산출표 팝업 컴포넌트 -->
    <TemperatureFeelTablePopup :visible.sync="showPopup" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import NumberInput from "@/components/NumberInput.vue";
import TemperatureFeelTablePopup from "./TemperatureFeelTablePopup.vue";

import TableInspectMerge from "@/components/TableInspectMerge.vue";

export default {
  components: {
    NumberInput,
    FileUploadModule,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
    TemperatureFeelTablePopup,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList_1 || this.form.inspectList_1.length === 0) {
          this.form.inspectList_1 = this.inspectTable_1;
        } else if ("note" in this.form.inspectList_1[0]) {
          this.form.inspectList_1 = this.form.inspectList_1.map((item) => {
            return {
              title: item.title,
              content: item.label,
              isChecked: this.setInspectChecked(item.is_checked),
              "비고(보완계획)": item.note,
            };
          });
        }

        if (!this.form || !this.form.inspectList_2 || this.form.inspectList_2.length === 0) {
          this.form.inspectList_2 = this.inspectTable_2;
        } else if ("note" in this.form.inspectList_2[0]) {
          this.form.inspectList_2 = this.form.inspectList_2.map((item) => {
            return {
              title: item.title,
              content: item.label,
              isChecked: this.setInspectChecked(item.is_checked),
              "비고(보완계획)": item.note,
            };
          });
        }

        if (!this.form || !this.form.inspectList_3 || this.form.inspectList_3.length === 0) {
          this.form.inspectList_3 = this.inspectTable_3;
        } else if ("note" in this.form.inspectList_3[0]) {
          this.form.inspectList_3 = this.form.inspectList_3.map((item) => {
            return {
              title: item.title,
              content: item.label,
              isChecked: this.setInspectChecked(item.is_checked),
              "비고(보완계획)": item.note,
            };
          });
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inspectionTitle = `${value.check_1 ? this.inspectionTitle_1 : ""}
            ${value.check_2 ? this.inspectionTitle_2 : ""}
            ${value.check_3 ? this.inspectionTitle_3 : ""}`;

        this.$emit("input", value);
      },
    },
    // 온도나 습도가 변경될 때마다 체감온도를 실시간으로 계산
    "form.temperature"() {
      this.calculateTemperatureFeel();
    },
    "form.humidity"() {
      this.calculateTemperatureFeel();
    },
  },
  data() {
    return {
      inspectionTitle_1: "폭염 작업",
      inspectionTitle_2: "풍수해 작업",
      inspectionTitle_3: "한랭 작업",

      form: {
        stdInfo: {},
        photoList: [],
        temperature: 0,
        humidity: 0,
        temperature_feel: 0,

        check_1: false,
        check_2: false,
        check_3: false,
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
        inspectList_3: [],
      },
      showPopup: false,
    };
  },
  mounted() {
    // 컴포넌트 마운트 시 체감온도 계산
    this.calculateTemperatureFeel();
  },
  computed: {
    checkboxItems() {
      return [
        {
          key: "check_1",
          title: this.inspectionTitle_1,
        },
        // {
        //   key: "check_2",
        //   title: this.inspectionTitle_2,
        // },
        {
          key: "check_3",
          title: this.inspectionTitle_3,
        },
      ];
    },
    inspectTable_1() {
      return [
        {
          title: "1. (물) 시원한 물 자주 마시기",
          content: "시원하고 깨끗한 물을 충분히 제공/식염포도당을 충분히 제공",
          isChecked: "",
        },
        {
          title: "2. (바람·그늘) 실내·옥외 작업장 온도 낮추기",
          content: "실내·옥외작업 시 (이동식)에어컨, 산업용 선풍기 등 냉방·통풍장치 및 그늘막 설치",
          isChecked: "",
        },
        {
          title: "2. (바람·그늘) 실내·옥외 작업장 온도 낮추기",
          content: "작업시간대 조정 등 폭염 집중 시간대 노출 최소화",
          isChecked: "",
        },
        {
          title: "3. (휴식) 주기적으로 쉬기",
          content: "작업장소와 가까운 곳에 휴게시설(쉼터) 설치, (이동식)에어컨, 산업용 선풍기, 시원한 물 비치",
          isChecked: "",
        },
        {
          title: "3. (휴식) 주기적으로 쉬기",
          content: "체감온도 31 도 이상 폭염작업 시 적절한 휴식",
          isChecked: "",
        },
        {
          title: "3. (휴식) 주기적으로 쉬기",
          content: "체감온도 33도 이상 폭염작업 시 2시간 이내 20분 이상 휴식",
          isChecked: "",
        },
        {
          title: "4. (보냉장구) 근로자 체온 낮추기",
          content: "냉각의류, 냉각조끼 등 개인 보냉장구 지급",
          isChecked: "",
        },
        {
          title: "5. (응급조치) 119에 신고하기",
          content: "온열질환자·의심자가 의식이 없는 경우 즉시 119 에 신고",
          isChecked: "",
        },
        {
          title: "5. (응급조치) 119에 신고하기",
          content: "의식이 있는 경우 응급조치 후 증상 개선 없을 시 119 신고",
          isChecked: "",
        },
        {
          title: "6. 그 외 예방조치",
          content: "작업장소의 체감온도를 알 수 있는 온습도계 비치",
          isChecked: "",
        },
        {
          title: "6. 그 외 예방조치",
          content: "온열질환 증상 및 예방방법 , 응급조치 요령 교육",
          isChecked: "",
        },
        {
          title: "6. 그 외 예방조치",
          content: "체감온도를 측정하고 조치사항 기록·보관",
          isChecked: "",
        },
        {
          title: "6. 그 외 예방조치",
          content: "온열질환 민감군 관리계획 수립\n * 신규배치자, 과거 온열질환 경력자, 고령자 등",
          isChecked: "",
        },
        {
          title: "6. 그 외 예방조치",
          content: "자율점검표, 자가진단표, 온열질환 예방지침 게시",
          isChecked: "",
        },
      ];
    },
    inspectTable_2() {
      return [
        {
          content: "풍수해 대비 비상매뉴얼은 작성하는가?",
          isChecked: "",
        },
        {
          content: "매뉴얼에 따른 업무분장이 적합한가?",
          isChecked: "",
        },
        {
          content: "사전 비상대비 훈련을 실시하는가?",
          isChecked: "",
        },
        {
          content: "예상 강우량에 따라 우수 유입량은 계산하는가?",
          isChecked: "",
        },
        {
          content: "현장 구간 내 시설물에 대한 우수 등의 유입에 대한 안전성평가가 이루어지는가?",
          isChecked: "",
        },
        {
          content: "배수계획도는 작성되었는가?",
          isChecked: "",
        },
        {
          content: "수방자재는 확보되었는가?\n" + "※ 양수기(고장 시 대비 여유분 포함), 마대, 가마니, 삽, 리어카, 우비, 장화, 렌턴 등",
          isChecked: "",
        },
        {
          content: "비상대기반을 편성하였는가?",
          isChecked: "",
        },
        {
          content: "작업중지 명령 체계가 확립되었는가?",
          isChecked: "",
        },
        {
          content: "발주처 및 원하청 간 비상 연락망은 구축되었으며 실제 운영하는가?",
          isChecked: "",
        },
        {
          content: "비상사태 발생 시 이에 대한 대책 수립을 하는가?\n" + "※ 집중호우 시 자재 및 장비 대피 계획 등",
          isChecked: "",
        },
      ];
    },
    inspectTable_3() {
      return [
        {
          content: "우리 사업장에서 한랭작업이 발생하거나 취급하는지에 대해 분류･파악하고 있는가?",
          isChecked: "",
        },
        {
          content: "우리 사업장에서 한랭의 유해성･위험성 및 관리방안을 근로자에게 주지시키고 있는가?",
          isChecked: "",
        },
        {
          content: "작업환경측정 등을 통해 근로자에게 노출되는 한랭 노출수준을 관리하고 있는가?",
          isChecked: "",
        },
        {
          content: "측정결과에 따라 적정한 열원 등의 적정한 관리방안을 마련하고 있는가?",
          isChecked: "",
        },
        {
          content: "근로자를 배치하기 전 근로자의 건강상태와 특성 등을 고려하여 배치하고 있는가?",
          isChecked: "",
        },
        {
          content: "저온환경의 격리와 작업장 내 온･습도 조절을 위한 난방장치 등이 설치되어 있는가?",
          isChecked: "",
        },
        {
          content: "작업의 강도에 따른 휴식시간을 적절히 부여하고, 쾌적한 휴게공간을 제공하고 있는가?",
          isChecked: "",
        },
        {
          content: "비상시 온도를 낮추거나 열을 차단할 수 있는 난방시스템이 구축되어 있는가?",
          isChecked: "",
        },
        {
          content: "근로자들이 휴식시간에 이용할 수 있는 휴게시설을 갖추고 있는가?",
          isChecked: "",
        },
        {
          content: "다량의 저온물체를 취급하는 장소 등에 관계근로자 외 출입을 금지하고 그 내용을 게시하고 있는가?",
          isChecked: "",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },

    /**
     * 습구온도(Tw) 계산
     * @param {number} ta 기온 (℃)
     * @param {number} rh 상대습도 (%)
     * @returns {number} 습구온도
     */
    getTw(ta, rh) {
      // 습구온도 계산공식 (Java 코드와 동일)
      return ta * Math.atan(0.151977 * Math.pow(rh + 8.313659, 0.5)) + Math.atan(ta + rh) - Math.atan(rh - 1.67633) + 0.00391838 * Math.pow(rh, 1.5) * Math.atan(0.023101 * rh) - 4.686035;
    },

    /**
     * 여름철 체감온도 계산 (5월 ~ 9월)
     * @param {number} ta 기온 (℃)
     * @param {number} rh 상대습도 (%)
     * @returns {number} 체감온도
     */
    getInSummer(ta, rh) {
      const tw = this.getTw(ta, rh);
      return -0.2442 + 0.55399 * tw + 0.45535 * ta - 0.0022 * Math.pow(tw, 2.0) + 0.00278 * tw * ta + 3.0;
    },

    /**
     * 겨울철 체감온도 계산 (10월 ~ 익년 4월)
     * @param {number} ta 기온 (℃)
     * @param {number} v 10분 평균 풍속 (m/s) - 풍속이 없는 경우 0.5를 기본값으로 사용
     * @returns {number} 체감온도
     */
    getInWinter(ta, v = 0.5) {
      return 13.12 + 0.6215 * ta - 11.37 * Math.pow(v, 0.16) + 0.3965 * Math.pow(v, 0.16) * ta;
    },

    /**
     * 현재 월수 출력
     * @returns {number} 현재 월 (1-12)
     */
    getCurrentSeason() {
      return new Date().getMonth() + 1; // getMonth()는 0부터 시작하므로 +1
    },

    /**
     * 값의 범위를 제한하는 함수
     * @param {number} value 입력값
     * @param {number} min 최소값
     * @param {number} max 최대값
     * @returns {number} 제한된 값
     */
    clampValue(value, min, max) {
      return Math.max(min, Math.min(max, value));
    },

    /**
     * 체감온도 계산 (실시간)
     * 지금이 몇월인지에 따라 여름 및 겨울 계산공식 적용
     */
    calculateTemperatureFeel() {
      let ta = parseFloat(this.form.temperature) || 0;
      let rh = parseFloat(this.form.humidity) || 0;

      // 온도와 습도 값을 범위 내로 제한
      ta = this.clampValue(ta, -20, 40); // 온도: -20℃ ~ 40℃
      rh = this.clampValue(rh, 0, 100); // 습도: 0% ~ 100%

      // 제한된 값을 다시 form에 적용
      if (this.form.temperature !== ta) {
        this.form.temperature = ta;
      }
      if (this.form.humidity !== rh) {
        this.form.humidity = rh;
      }

      // 유효하지 않은 값인 경우 체감온도를 0으로 설정
      if (ta < -20 || ta > 40 || rh < 0 || rh > 100) {
        this.form.temperature_feel = 0;
        return;
      }

      // 현재 계절에 따라 체감온도 계산 공식 적용
      const season = this.getCurrentSeason();
      let temperatureFeel = 0;

      if (season >= 5 && season <= 9) {
        // 여름철 체감온도 계산 (5월~9월)
        temperatureFeel = this.getInSummer(ta, rh);
      } else {
        // 겨울철 체감온도 계산 (10월~4월)
        // 풍속이 없으므로 기본값 0.5 m/s 사용
        temperatureFeel = this.getInWinter(ta, 0.5);
      }

      this.form.temperature_feel = parseFloat(temperatureFeel.toFixed(1));
    },

    setInspectChecked(data) {
      if (data === "Yes") return "양호";
      else if (data === "No") return "미흡";
      else if (data === "N/A") return "해당없음";
      else return "";
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}

.temp-tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
}

@media print {
  .print-page-break {
    break-before: page;
    page-break-before: always;
  }
}
</style>
